import { computed, inject, Injectable, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

import { IAuthStore } from 'shared/auth/store/auth.reducer';
import { PrivilegeService } from 'shared/services/privilege.service';

@Injectable({
	providedIn: 'root',
})
export class AdminPrivilegeService implements PrivilegeService {
	private readonly store = inject(Store<{ auth: IAuthStore }>);

	privileges = this.store.selectSignal((state) => state.auth.privileges);
	privileges$ = toObservable(this.privileges).pipe(filter((privileges): privileges is string[] => !!privileges));

	roles = this.store.selectSignal((state) => state.auth.roles);
	roles$ = toObservable(this.roles).pipe(filter((roles): roles is string[] => !!roles));

	hasPrivilege(privilege: string | string[]): Signal<boolean> {
		return this.hasAny(privilege, this.privileges);
	}

	hasRole(role: string | string[]): Signal<boolean> {
		return this.hasAny(role, this.roles);
	}

	hasAccess(privilege: string | string[], role: string | string[]): Signal<boolean> {
		return computed(() => this.hasPrivilege(privilege)() || this.hasRole(role)());
	}

	private hasAny(required: string | string[], granted: Signal<string[] | undefined>): Signal<boolean> {
		const list = [required].flat();
		return computed(() => list.some((item) => granted()?.includes(item)));
	}
}
